type IconProps = {
	width?: number;
	height?: number;
	maskColor?: string;
	color?: string;
}

export const RCCPKIcon = (props: IconProps) => {
	const {
		width = 18,
		height = 18,
		maskColor = '#D9D9D9',
		color = '#1C1B1F'
	} = props;
	return (
		<svg role={'img'} xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 18 18' fill='none'>
			<mask id='mask0_3997_29826' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='-1' y='0' width='19' height='18'>
				<rect x='-0.00683594' width='17.5' height='17.5' fill={maskColor} />
			</mask>
			<g mask='url(#mask0_3997_29826)'>
				<path d='M6 13H7.66667V15H9.33333V13H11V10H9.33333V11H7.66667V7H9.33333V8H11V5H9.33333V3H7.66667V5H6V13Z' fill={color} />
			</g>
		</svg>
	);
};
